require('../../../modules/es.array.concat');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').concat;



// WEBPACK FOOTER //
// webpack://idx/node_modules/core-js-pure/es/array/virtual/concat.js